import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { user } from "../../store/auth/actions";

export const useUserGetAll = (
  trigger: boolean,
  users: string,
  page: number,
  limit: number,
  query: string,
) => {
  const dispatch = useDispatch();

  const { responseUser, errorUser, loadingUser, pagingInfo } = useSelector(
    (state: any) => ({
      responseUser: state.Login.responseUser?.data,
      pagingInfo: state.Login.responseUser?.pagingInfo,
      errorUser: state.Login.errorUser,
      loadingUser: state.Login.loadingUser,
    }),
  );

  useEffect(() => {
    if (trigger) {
      dispatch(
        user({
          users: users,
          orderBy: "createdAt",
          orderDir: "desc",
          enabled: true,
          page: page,
          limit: limit,
          query: query,
          deleted: false,
        }),
      );
    }
  }, [trigger]);

  return {
    responseUser,
    pagingInfo,
    errorUser,
    loadingUser,
  };
};